import { mapConfig } from "./map-config";

/**
 * Zoom in on a point
 *
 * @param oldScale [number] The previous scale
 * @param scaleChanged [number] Scale factor
 * @param originX [number] Mouse or touch x coordinate
 * @param originY [number] Mouse or touch y coordinate
 * @param currentCenterX [number] Current center x coordinate
 * @param currentCenterY [number] Current center y coordinate
 */
export const zoomInOnPoint = (
  oldScale: number,
  scaleChanged: number,
  originX: number,
  originY: number,
  currentCenterX: number,
  currentCenterY: number
): { offsetY: number; offsetX: number; newScale: number } => {
  // Change the scale
  let newScale = (oldScale *= scaleChanged);

  // Return if newScale is not within bounds.
  if (newScale >= mapConfig.zoom.max || newScale <= mapConfig.zoom.min) {
    if (Math.sign(scaleChanged) < 0) {
      // zooming out
      scaleChanged = 1;
      newScale = 0.2;
    } else {
      // zooming in
      newScale = 1.2;
      scaleChanged = 1;
    }
    // return {};
  }

  // Find distance between wheel origin and center coords
  const mousePosToCurrentCenterDistanceX = originX - currentCenterX;
  const mousePosToCurrentCenterDistanceY = originY - currentCenterY;

  // Calculate what the new center coords should be
  const newCenterX =
    currentCenterX + mousePosToCurrentCenterDistanceX * (1 - scaleChanged);
  const newCenterY =
    currentCenterY + mousePosToCurrentCenterDistanceY * (1 - scaleChanged);

  // Calculate the offset we will translate by
  const offsetX = currentCenterX - newCenterX;
  const offsetY = currentCenterY - newCenterY;

  return {
    offsetX,
    offsetY,
    newScale,
  };
};
